import type { CorporateHeroSectionOption } from '../types/corporateHero';

interface TabSectionLike {
  id?: string;
  title?: string;
}

interface SubTabLike {
  id?: string;
  title?: string;
  name?: string;
  sections?: TabSectionLike[];
}

interface TabLike {
  id?: string;
  name?: string;
  title?: string;
  sections?: TabSectionLike[];
  subTabs?: SubTabLike[];
}

/** Özel sekme / alt sekme bölümlerinden hero kaydırma seçenekleri üretir. */
export function collectCustomTabSectionOptions(
  tabs?: TabLike[] | null
): CorporateHeroSectionOption[] {
  const options: CorporateHeroSectionOption[] = [];

  for (const tab of tabs || []) {
    const tabName = (tab.name || tab.title || '').trim();
    const tabId = String(tab.id || '').trim();

    for (const section of tab.sections || []) {
      if (!section?.id) continue;
      const title = (section.title || '').trim() || 'Bölüm';
      options.push({
        label: tabName ? `${tabName} — ${title}` : title,
        value: `section-${section.id}`,
      });
    }

    // Ana sekme SSS (ürün/çözümler sayfa SSS'si gibi alt başlık altında konum)
    if (tabId) {
      options.push({
        label: tabName ? `${tabName} — SSS` : 'SSS',
        value: `faq_tab_${tabId}`,
      });
    }

    for (const subTab of tab.subTabs || []) {
      if (!subTab?.id) continue;
      const subTitle = (subTab.title || subTab.name || '').trim() || 'Alt Sekme';
      options.push({
        label: tabName ? `${tabName} — ${subTitle}` : subTitle,
        value: `subtab-${subTab.id}`,
      });

      for (const section of subTab.sections || []) {
        if (!section?.id) continue;
        const title = (section.title || '').trim() || 'Bölüm';
        options.push({
          label: tabName ? `${tabName} / ${subTitle} — ${title}` : `${subTitle} — ${title}`,
          value: `section-${section.id}`,
        });
      }

      options.push({
        label: tabName ? `${tabName} / ${subTitle} — SSS` : `${subTitle} — SSS`,
        value: `faq_tab_${subTab.id}`,
      });
    }
  }

  return options;
}

export function buildHeroSectionOptions(
  fixed: CorporateHeroSectionOption[],
  tabs?: TabLike[] | null
): CorporateHeroSectionOption[] {
  const seen = new Set<string>();
  const merged: CorporateHeroSectionOption[] = [];

  for (const option of [...fixed, ...collectCustomTabSectionOptions(tabs)]) {
    if (!option.value || seen.has(option.value)) continue;
    seen.add(option.value);
    merged.push(option);
  }

  return merged;
}
